<template>
  <section class="specs-holder">
    <template v-if="!compact">
      <spec class="spec title" v-if="file.template">{{ file.template }}</spec>
      <spec class="spec title" v-else>Op maat</spec>
      <spec :title="'Formaat: ' + file.format"
        ><span class="spec-title">{{ file.format }}</span></spec
      >

      <spec
        ><span class="spec-title">{{ file.colorMode }}</span></spec
      >

      <spec :title="file.side"
        ><span class="spec-title">{{ file.side }}</span>
      </spec>
      <spec v-show="!file.paperType"
        ><span class="spec-title">{{ file.material }}</span></spec
      >
      <spec v-show="file.paperType"
        ><span class="spec-title">{{ file.paperType }}</span></spec
      >
      <spec v-show="file.treatment"
        ><span class="spec-title">{{ file.treatment }}</span></spec
      >
    </template>
  </section>
</template>

<script>
import Spec from './Spec.vue'
export default {
  components: { Spec },
  props: ['file', 'compact']
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
}
</style>
